import { requestApi } from '../util/network'

export const register =
(phone, verifyCode, userName, password, password2) =>
  requestApi(
    '/o2o_distributor/register',
    'POST',
    {
      'user_name': userName,
      'phone': phone,
      'verify_code': verifyCode,
      'password': password,
      'password2': password2,
      'client_type': 'wap'
    }
  )
